/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// RequreJS Config
requirejs.config({
    waitSeconds: 90,
    //add shims, etc here.
    paths: {
        "jquery": 'plugins/jquery.min',
        "lodash": 'plugins/lodash.min',
        "moment": 'plugins/moment.min',
        "handlebars": 'plugins/handlebars.min'
    },
    shim: {
        // Handlebars, (precompiled) templates and helpers
        'handlebars': {
            exports: 'Handlebars'
        },
        'handlebarsUtils': {
            deps: ['handlebars'],
            exports: 'Handlebars'
        },
        "plugins/affix": {
            deps: ['jquery', 'plugins/transition']
        },
        "plugins/collapse": {
            deps: ['jquery', 'plugins/transition']
        },
        "plugins/jquery.truncator": {
            deps: ['jquery']
        },
        "plugins/jquery.zoomswap": {
            deps: ['jquery']
        },
        "plugins/imagesloaded.pkgd.min": {
            deps: ['jquery']
        },
        "plugins/magnific-popup": {
            deps: ['jquery']
        },
        "plugins/jquery.matchHeights": {
            deps: ['jquery']
        },
        "plugins/slick": {
            deps: ['jquery']
        },
        "plugins/jquery.rateit.min": {
            deps: ['jquery']
        },
        "plugins/jquery.debouncedresize": {
            deps: ['jquery']
        },
        "plugins/transition": {
            deps: ['jquery']
        },
        "plugins/dismissable": {
            deps: ['jquery']
        },
        "plugins/toastr": {
            deps: ['jquery']
        },
        "plugins/jquery.blockUI": {
            deps: ['jquery']
        },
        "plugins/jquery.proxyRequest": {
            deps: ['jquery']
        },
        "plugins/jquery.addresscomplete": {
            deps: ['jquery']
        },
        "plugins/jquery.ziplookup": {
            deps: ['jquery']
        },
        "plugins/moment-timezone.min": {
            deps: ['moment']
        },
        "plugins/jquery.rocparams": {
            deps: ['jquery']
        },
        "plugins/jquery-ui.min": {
            deps: ['jquery']
        },
    }
});

define('RocInit',['modules/all', 'global/validation'], function (Modules, Validation) {
    Validation.bindGlobalEvents();
});

